<template>
  <div
    :class="[
      'qc-flavor-container',
      selected ? 'selected' : '',
    ]"
    @click="handleClicked"
  >
    <div class="qc-flavor-image"><img :src="imageAssetURL" :alt="imageAltText" /></div>
    <slot>
    </slot>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted, onBeforeUpdate } from '@vue/composition-api';
import gsap from 'gsap';

export default {
  name: 'QuizFlavorImage',
  components: {

  },
  props: {
    imageAssetURL: {
      type: String,
      default: '',
    },
    imageAltText: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, context) {

    const handleClicked = () => {
      // console.log('handleClicked');
      context.emit('clicked');
    }

    return {
      handleClicked,
    }
  }
}
</script>

<style lang="scss" scoped>
$flavor-image-padding: 5%;

.qc-flavor-container {
  position: relative;
  // display: inline-block;
  width: 44%;
  max-width: 160px;

  &.selected {
    .qc-flavor-image {
      // top: #{$flavor-image-padding};
      // left: #{$flavor-image-padding};
      opacity: 0.7;

      &::before {
        display: none;
      }

      &::after {
        display: block;
      }

      img {
        // top: #{$flavor-image-padding};
        // left: #{$flavor-image-padding};
        transform: translate3d(#{$flavor-image-padding}, #{$flavor-image-padding}, 0);
      }
    }
  }

  &.wrong {
    .qc-flavor-image {
      img {
        filter: grayscale(1);
      }
    }

    .qc-flavor-wrong-black-overlay {
      display: block;
    }

    .qc-flavor-wrong-overlay {
      display: block;
    }
  }
}

.qc-flavor-image {
  position: relative;
  width: 90%;
  margin: 0 auto;

  &::before, &::after {
    position: absolute;
    display: block;
    content: '';
    width: 100%;
    padding-top: 100%;
    top: #{$flavor-image-padding};
    left: #{$flavor-image-padding};
    border-radius: 50%;
    background-color: $bg-shadow-blue-color;
  }

  &::after {
    display: none;
    // top: 0;
    // left: 0;
    background-color: transparent;
    background-image: url('~@/assets/images/flavor_selected_inner_shadow.png');
    background-size: cover;
    // opacity: 0.28;
  }

  img {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }

}

.qc-flavor-wrong-black-overlay {
  position: absolute;
  top: 2%;
  left: 7%;
  width: 86%;
  height: 92%;
  background-color: #000;
  opacity: 0.5;
  border-radius: 50%;
  display: none;
}

.qc-flavor-wrong-overlay {
  position: absolute;
  top: 0;
  left: 5%;
  width: 90%;
  height: 100%;
  background-image: url('~@/assets/images/quiz/quiz_flavor_wrong_slash.png');
  background-repeat: no-repeat;
  background-size: contain;
  display: none;
}
</style>
